import { useUnit } from 'effector-react';
import { $notificationStore, NotificationType } from '@lib/store';
import { cn, PaletteUtils } from '@shared/utils';
import { Text } from '@shared/widgets';

export const Notification = () => {
  const notification = useUnit($notificationStore.store);

  if (!notification) return null;
  return (
    <div
      className={cn('fixed left-0 right-0 top-0 z-[50000] w-dvw border bg-white dark:bg-soft-black', [
        notification.type === NotificationType.Error && 'border-red',
        notification.type === NotificationType.Warning && 'border-primary',
        notification.type === NotificationType.Success && 'border-green',
      ])}
    >
      <Text className='p-3 text-center' weight='semibold' color={PaletteUtils.getNotificationColor(notification.type)}>
        {notification.message}
      </Text>
    </div>
  );
};
